module.exports = __webpack_public_path__ + "img/partners_huizhixinyuan.b951052c.png";